/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'nhs/arrow-right': {
    width: 24,
    height: 18,
    viewBox: '0 0 24 18',
    data: '<path pid="0" d="M23.47 7.764L16.067.502a1.809 1.809 0 00-2.5 0 1.727 1.727 0 000 2.453l4.369 4.313H1.768C.784 7.268 0 8.037 0 9.003c0 .966.784 1.735 1.768 1.735h16.169l-4.37 4.288a1.727 1.727 0 000 2.453 1.795 1.795 0 002.526 0l7.376-7.237c.329-.322.531-.768.531-1.239 0-.47-.177-.917-.53-1.24z" _fill="#fff"/>'
  }
})
